import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../components/UI/Loader";
import { getPendingLoginReturnTo, setPendingLoginReturnTo } from "../utils/auth0LoginReturnService";

const Login = () => {
  const { loginWithRedirect, isLoading } = useAuth0();
  const location = useLocation();
  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo ||
    getPendingLoginReturnTo() ||
    '/home';

  useEffect(() => {
    if (!isLoading) {
      // Retain the destination if Auth0 expires the hosted login transaction
      // and sends the browser to this application's default login route.
      setPendingLoginReturnTo(returnTo);
      loginWithRedirect({ appState: { returnTo } });
    }
  }, [isLoading, loginWithRedirect, returnTo]);

  return (
    <div className="section">
      <Loader />
    </div>
  )
};

export default Login;
